import React, { useState, useEffect, createRef } from "react";
import Button from "@material-ui/core/Button";
import { DialogTitle } from "../../components/ui/Dialog/CustomDialog";
import CancelIcon from "@material-ui/icons/Cancel";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import {
  Dialog,
  // DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  DialogActions,
  MenuItem,
  InputLabel,
  Select,
  LinearProgress,
  Tooltip,
  Typography,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  IconButton,
} from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import { getAddressIssueTypes } from "../../serviceClients/addressingClient";
import axios from "axios";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { useTranslation } from "react-i18next";
import { appConifg } from "../../config/default";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import ReactGA from "react-ga";

const IssueTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const ReportIssueDialog = (props) => {
  const { t, i18n } = useTranslation("reportIssuePage");
  const formRef = createRef();
  const [comments, setComments] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [showReportAlert, setShowReportAlert] = useState(false);
  const [alertReportType, setAlertReportType] = useState("");
  const [alertReportMsg, setAlertReportMsg] = useState("");
  const [issueType, setIssueType] = useState(1);
  const [issueTypes, setIssueTypes] = useState([]);
  const [attachment, setAttachment] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [showAttachError, setShowAttachError] = useState(false);

  useEffect(() => {
    if (issueTypes.length == 0) {
      const [promise, promiseIssueType] = getAddressIssueTypes(
        props.appSettings.userCredentials.token.access_token
      );
      promise.then((response) => {
        console.log(response.data);
        if (response.data.isSucceeded) setIssueTypes(response.data.data);
      });
    }
    if (props.appSettings.userCredentials) {
      if (props.appSettings.userCredentials.uaePassUser) {
        setName(
          props.appSettings.language == "en"
            ? props.appSettings.userCredentials.uaePassUser.fullnameEN
            : props.appSettings.userCredentials.uaePassUser.fullnameEN
        );
        setEmail(props.appSettings.userCredentials.uaePassUser.email);
        setPhone(props.appSettings.userCredentials.uaePassUser.mobile);
      }
    }
  }, []);
  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
      console.log(fileInfo);
    });
  };

  const handleFileInputChange = (e) => {
    Array.from(e.target.files).forEach((element) => {
      getBase64(element)
        .then((result) => {
          setAttachment((old) => [
            ...old,
            {
              id: element.lastModified,
              FileName: element.name.split(".")[0].toString(),
              FileExtension: "." + element.name.split(".")[1].toString(),
              FileContent: result,
            },
          ]);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  const removeIdProps = () => {
    const items = attachment.filter((item) => delete item.id);
    return items;
  };

  const removeFileItem = (id) => {
    const items = attachment.filter((item) => item.id !== id);
    setAttachment(items);
  };

  const handleReportSubmit = () => {
    if (attachment.length < 1) {
      setShowAttachError(true);
      return;
    }

    setIsLoading(true);
    const data = {
      ReportUserName: name.trim(),
      Email: email.trim(),
      Mobile: phone.trim(),
      Latitude: props.lat,
      Longitude: props.lng,
      FK_Issue_TypeId: issueType,
      FK_Issue_StatusId: 1,
      searchedText: "",
      reporterDescription: comments.trim(),
      Attachments: removeIdProps(),
      ArabicEmailFormat: props.appSettings.language == "en" ? false : true,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + props.token.access_token,
    };
    axios
      .post(
        appConifg.Address.AddressApiUrl + "/AddressingIssues/CreateIssue",
        data,
        { headers: headers }
      )
      .then((response) => {
        if (response.data.isSucceeded) {
          setIsLoading(false);
          props.onClose();
          props.onSuccess("Issue reported successfully!");
          ReactGA.event({
            category: "ReportIssue",
            action: "Issue reported",
          });
        } else {
          setIsLoading(false);
          setAlertReportMsg(response.data.status.message);
          setAlertReportType("error");
          setShowReportAlert(true);
        }
      })
      .catch((ex) => {
        setIsLoading(false);
        setAlertReportMsg("Connection error, please try again!");
        setAlertReportType("error");
        setShowReportAlert(true);
      });
  };

  const handleIssueTypeChange = (event) => {
    setIssueType(event.target.value);
  };
  ValidatorForm.addValidationRule("isPhoneValid", () => {
    if (
      phone.match(
        /^(?:\+971|00971|971|0)?(?:50|51|52|55|56|58|2|3|4|6|7|9)\d{7}$/m
      )
    ) {
      return true;
    }
    return false;
  });

  ValidatorForm.addValidationRule("isAttachementExists", () => {
    if (attachment.length > 0) return true;
    else return false;
  });

  return (
    <Dialog
      className="customeBorder"
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="form-dialog-title"
      disableBackdropClick={true}
    >
      <DialogTitle
        id="form-dialog-title"
        onClose={props.onClose}
        disabled={isLoading}
      >
        {t("DialogTitle")}
      </DialogTitle>
      <ValidatorForm ref={formRef} onSubmit={handleReportSubmit}>
        <DialogContent>
          <DialogContentText>{t("ReportIssueInfo")}</DialogContentText>
          <TextValidator
            autoFocus
            margin="dense"
            disabled={
              props.appSettings.userCredentials.uaePassUser ? true : false
            }
            id="reportName"
            label={t("name")}
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            validators={[
              "required",
              "matchRegexp:^[A-Za-zs.()0-9, ]{4,}(?: [A-Za-zs.()0-9, ]+){0,2}(?: [A-Za-zs.()0-9, ]+){0,3}$",
              //"matchRegexp:*",
            ]}
            errorMessages={[t("ReqFieldErrorMsg"), t("ErrorInvalidName")]}
          />
          <TextValidator
            autoFocus
            margin="dense"
            disabled={
              props.appSettings.userCredentials.uaePassUser ? true : false
            }
            id="reportEmail"
            value={email}
            label={t("EmailAddress")}
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            validators={["required", "isEmail"]}
            errorMessages={[t("ReqFieldErrorMsg"), t("ErrorInvalidEmail")]}
          />
          <TextValidator
            autoFocus
            margin="dense"
            disabled={
              props.appSettings.userCredentials.uaePassUser ? true : false
            }
            id="reportPhone"
            label={t("PhoneNumber")}
            type="Phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            fullWidth
            validators={["required", "isPhoneValid"]}
            errorMessages={[t("ReqFieldErrorMsg"), t("ErrorInvalidPhone")]}
          />
          <InputLabel
            id="issueTypes-select-label"
            style={{ marginTop: "8px", marginBottom: "4px" }}
          >
            {t("IssueType")}
          </InputLabel>
          <Select
            labelId="issueTypes-select-label"
            id="issueSelect"
            value={issueType}
            autoFocus
            fullWidth
            margin="dense"
            onChange={handleIssueTypeChange}
            //validators={["required"]}
            //required
            //errorMessages={t("ReqFieldErrorMsg")}
          >
            {issueTypes.map((Type) => (
              <IssueTooltip
                value={Type.id}
                title={
                  <React.Fragment>
                    {/* <Typography color="inherit">
                      {props.appSettings.language == "en"
                        ? Type.nameEN
                        : Type.nameAR}
                    </Typography> */}
                    <Typography>
                      {props.appSettings.language == "en"
                        ? Type.detailsNameEN
                        : Type.deatilsNameAR}
                    </Typography>
                  </React.Fragment>
                }
              >
                {/* <Tooltip
                  placement="top"
                  arrow
                  title={
                    props.appSettings.language == "en"
                      ? Type.detailsNameEN
                      : Type.deatilsNameAR
                  }
                  value={Type.id}
                > */}
                <div>
                  <MenuItem>
                    <b>
                      {props.appSettings.language == "en"
                        ? Type.nameEN
                        : Type.nameAR}
                    </b>
                  </MenuItem>
                </div>
                {/* </Tooltip> */}
              </IssueTooltip>
            ))}
          </Select>

          {/* {
           (!issueType)  
            ? 
            <p class="MuiFormHelperText-root Mui-error MuiFormHelperText-filled MuiFormHelperText-marginDense"> 
            {"Please Choose Issue Type"}
            </p>
            :null
          } */}

          <TextValidator
            id="IssueComments"
            label={t("Comments")}
            margin="dense"
            // required
            validators={["required"]}
            value={comments}
            multiline
            rows={5}
            onChange={(e) => setComments(e.target.value)}
            fullWidth
            errorMessages={t("ReqFieldErrorMsg")}
          />
          {/* <TextValidator
           
            margin="dense"
            disabled="false"
            id="noOfAttachments"
            label={t("Attachments")}
            type="text"
            value={attachment.length}
            fullWidth
            validators={["isAttachementExists"]}
            errorMessages={["Please upload attachments", "Invalid Attachments"]}
          /> */}

          <input
            id="issueAttachment"
            type="file"
            accept="image/*"
            multiple
            margin="dense"
            style={{ display: "none" }}
            fullWidth
            onChange={handleFileInputChange}
            name="report_attach_input"
          />
          <InputLabel
            htmlFor="issueAttachment"
            style={{ marginTop: "8px", marginBottom: "4px" }}
          >
            <Button
              variant="contained"
              color="primary"
              component="span"
              name="report_attachments"
            >
              {t("Attachments")}
            </Button>
          </InputLabel>
          {showAttachError && attachment.length < 1 ? (
            <p class="MuiFormHelperText-root Mui-error MuiFormHelperText-filled MuiFormHelperText-marginDense">
              {t("UploadAttchErrorMsg")}
            </p>
          ) : null}

          <List dense={true}>
            {attachment.map((file) => {
              return (
                <ListItem>
                  <ListItemText primary={file.FileName + file.FileExtension} />
                  <ListItemSecondaryAction>
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => removeFileItem(file.id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => props.onClose()}
            color="secondary"
            variant="outlined"
            disabled={isLoading}
            startIcon={<CancelIcon />}
          >
            {t("Cancel")}
          </Button>
          <Button
            type="submit"
            color="primary"
            disabled={isLoading}
            variant="outlined"
            startIcon={<EditIcon />}
          >
            {t("Confirm")}
          </Button>
        </DialogActions>
        {isLoading ? <LinearProgress /> : ""}
      </ValidatorForm>
      {showReportAlert ? (
        <Alert severity={alertReportType}>
          <AlertTitle>
            {alertReportType == "success" ? "Success" : "Error"}
          </AlertTitle>
          {alertReportMsg}
        </Alert>
      ) : (
        ""
      )}
    </Dialog>
  );
};
const mapStateToProps = (state) => {
  return {
    appSettings: state.settings,
  };
};
export default connect(mapStateToProps, null)(ReportIssueDialog);
